import { textAtomTypeId } from '@/enums';
import { useEntityTextSave } from './useEntityTextSave';

interface UpdateActSynopsisData {
    actId: number;
    content: string;
    textAtomId?: number;
}

export function useUpdateActSynopsis() {
    return useEntityTextSave<UpdateActSynopsisData>({
        entity: 'act',
        action: 'updateSynopsis',
        typeId: textAtomTypeId.act_plot,
        entityIdOf: ({ actId }) => actId,
    });
}
